$(document).ready(function (e) {
    $('.sortable-webform-mapping').sortable({
        cursor: 'grab',
        connectWith: ".sortable-webform-mapping",
    });

    $('#webform-table').on('change', function (e) {
        $('.webform-mappings-holder').empty();
    });

    $(document).on('change', '.field-value-type, .web-form-field', function (e) {
        let value = parseInt($(this).val());

        let $mapping = $(this).parents('.webform-mapping'),
            $custom_value = $($mapping).find('.custom-value-holder'),
            field = $($mapping).find('.web-form-field').val(),
            field_type = $($mapping).find('.web-form-field').find('option:selected').attr('data-field-type'),
            field_type_value = parseInt($($mapping).find('.field-value-type').val()),
            required = parseInt($(this).find(':selected').attr('data-is-required'));

        if (!field_type.length || !field.length) {
            return;
        }

        if(required === 1){
            $mapping.find('.toggle-required').prop('checked', true);
        }else{
            $mapping.find('.toggle-required').prop('checked', false);
        }

        if (field_type_value === 2) {
            $mapping.find('.field-custom-value').val('').attr('disabled', false);
            $.ajax({
                type: 'GET',
                url: '/tables/field/render',
                data: {
                    field: field,
                    webform: true
                },
                success: function (res) {
                    if (res) {
                        $custom_value.html(res).removeClass('d-none');
                        $('.selectpicker').selectpicker('refresh');
                    }
                }
            });
        } else {
            $($mapping).find('.custom-value-holder').empty();
        }
    });

    $('.add-webform-mapping').on('click', function (e) {
        let table_id = $('#webform-table').val();
        if (table_id.length) {
            $.ajax({
                type: "GET",
                url: '/settings/web_forms/mapping',
                data: {
                    table_id
                },
                success: function (mapping) {
                    $('.webform-mappings-holder').append(mapping);
                    $('.sortable-webform-mapping').sortable({
                        cursor: 'grab',
                        connectWith: ".sortable-webform-mapping",
                    });
                }
            });
        } else {
            alert('Please select Table');
        }
    });

    $(document).on('click', '.remove-webform-mapping', function (e) {
        $(this).parents('.webform-mapping').remove();
    });

    if($('.webform-builder-form').length){
        $(window).keydown(function(event){
            if( (event.keyCode == 13)) {
                event.preventDefault();
                return false;
            }
        });
    }

    $('.webform-builder-form').one('submit', handleWebFormBuilderFormChange);

    function handleWebFormBuilderFormChange(e) {
        e.preventDefault();

        let errors = false,
            $mappings = $('.webform-mappings-holder').find('.webform-mapping'),
            webform_mappings = [];

        if (!$mappings.length) {
            errors = true;
            alert('Please add mappings');
        } else {
            $mappings.each(function (index, $mapping) {
                let field = $($mapping).find('.web-form-field').val(),
                    type = $($mapping).find('.field-value-type').val(),
                    field_type = $($mapping).find('.web-form-field').find('option:selected').attr('data-field-type'),
                    field_type_value = parseInt($($mapping).find('.field-value-type').val()),
                    $link =  $($mapping).find('.add-label-link'),
                    required = $($mapping).find('.toggle-required').is(':checked') ? 1 : 0,
                    link_text = $link.attr('data-text'),
                    link_url = $link.attr('data-link'),
                    open_blank = $link.attr('data-open-blank'),
                    value = '';

                if (parseInt(type) === 2) {
                    value = $($mapping).find('.custom-value').val();

                    if ($($mapping).find('select.custom-value').length) {
                        value = $($mapping).find('select.custom-value').val();
                    }

                    let date_payload = {};

                    if (field_type === 'date') {
                        date_payload.type = 'date';
                        let days = $($mapping).find('.days').val();
                        date_payload.days = days;

                        value = JSON.stringify(date_payload);
                    } else if (field_type === 'datetime') {
                        date_payload.type = 'datetime';
                        let days = $($mapping).find('.days').val(),
                            hours = $($mapping).find('.hours').val(),
                            minutes = $($mapping).find('.minutes').val();
                        date_payload.days = days;
                        date_payload.hours = hours;
                        date_payload.minutes = minutes;
                        value = JSON.stringify(date_payload);
                    }
                }

                if (!field.length) {
                    errors = true;
                    alert('Please select field');
                }

                webform_mappings.push({
                    field,
                    type: type,
                    value: value,
                    url: link_url,
                    text: link_text,
                    open_new_tab: open_blank,
                    required : required
                });

                console.log({
                    field,
                    type: type,
                    value: value,
                    url: link_url,
                    text: link_text,
                    open_new_tab: open_blank,
                    required : required
                });
            });
        }

        if (!errors) {
            $('input[name="webform_mappings"]').val(JSON.stringify(webform_mappings));
            $(this).submit();
            $('.webform-builder-form').one('submit', handleWebFormBuilderFormChange);
        } else {
            $('.webform-builder-form').one('submit', handleWebFormBuilderFormChange);
        }
    }

    $('.delete-webform-builder').on('click', function (e) {
        e.preventDefault();

        let id = $(this).attr('data-id');

        if (confirm('Are you sure you want to delete this Web Form')) {
            $.ajax({
                type: 'DELETE',
                url: '/settings/web_forms',
                data: {
                    id
                },
                success: (res) => {
                    if (res) {
                        $(this).parents('tr').remove();
                    }
                }
            });
        }
    });

    $('.duplicate-webform-builder').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');

        $.ajax({
            type: 'POST',
            url: '/settings/web_forms/duplicate',
            data: {
                id
            },
            success: function (id) {
                window.location = '/settings/web_forms/edit/' + id;
            }
        });
    });


    let $active_webform_link = null;

    $(document).on('click', '.add-label-link', function(e){
        $active_webform_link = $(this);
        let link = $(this).attr('data-link'),
            text = $(this).attr('data-text'),
            open_tab = parseInt($(this).attr('data-open-blank'));

        $('#link-text').val(text);
        $('#link-url').val(link);
        if(open_tab){
            $('#link-new-tab').prop('checked', true);
        }else{
            $('#link-new-tab').prop('checked', false);
        }
        $('#link-modal').modal('toggle');
    });

    $('.save-link').on('click', function(e){
        let text = $('#link-text').val(),
            link = $('#link-url').val(),
            open_tab = $('#link-new-tab').is(':checked') ? 1 : 0;

        if(text.length && link.length){
            $active_webform_link.addClass('has-link');
        }else{
            $active_webform_link.removeClass('has-link');
        }

        $active_webform_link.attr('data-link', link)
                            .attr('data-text', text)
                            .attr('data-open-blank', open_tab);

        $('#link-modal').modal('toggle');
    })

});